module.exports = global["wysihtml"] = require("-!/data/projects/libraries/angular2-voog-wysihtml/src/vendor/wysihtml.js");


//////////////////
// WEBPACK FOOTER
// ./src/vendor/wysihtml.js
// module id = 3
// module chunks = 0